import {
  Box,
  Container,
  HStack,
  Icon,
  Stack,
  VStack,
  Text,
  Heading,
} from "@chakra-ui/react";
import React from "react";

export interface SummaryFieldItems {
  title: string | React.ReactElement;
  text?: string;
  headingText?: string;
  icon?: any;
  full?: boolean;
  isChanged?: boolean;
  originalValue?: string;
  modifiedValue?: string;
}

interface SummaryFieldsProps {
  items: SummaryFieldItems[];
  iconColor?: string;
  componentKey: string;
}

export const SummaryFields: React.FC<SummaryFieldsProps> = ({
  items,
  iconColor = "green",
  componentKey,
}) => (
  <Container maxW={"6xl"} my={4} px={0}>
    <Stack
      direction={{ base: "column", md: "row" }}
      mb={"6px"}
      wrap={"wrap"}
      rowGap={8}
    >
      {items.map((item, index) => (
        <HStack
          key={componentKey + index}
          align={"top"}
          w={{ base: "98%", md: item.full ? "98%" : "49%" }}
          display={{
            base: item.text === "" && item.title === "" ? "none" : "flex",
            md: "flex",
          }}
          borderRadius={item.isChanged ? "lg" : "none"}
          p={item.isChanged ? 2 : 0}
          _before={
            item.isChanged
              ? {
              content: '""',
              position: "absolute",
              inset: "0px",
              zIndex: -1,
              borderRadius: "lg",
              filter: "blur(4px)",
              pointerEvents: "none",
                  boxShadow: `
              -3px -3px 8px rgba(245, 101, 101, 0.15),
                1.5px -2px 9px rgba(237, 100, 166, 0.15),
              -4.5px  1.5px 10px rgba(237, 137,  54, 0.15),
                1.5px  3px 8px rgba(237, 100, 166, 0.125),
              -3px 5.5px 8px rgba(245, 101, 101, 0.125),
                3px -3px 9px rgba(237, 137,  54, 0.125)
            `,
                }
              : undefined
          }
          zIndex={0}
          position="relative"
        >
          {item.icon && (
            <Box color={iconColor + ".400"} px={2}>
              {item.icon && <Icon w={"16px"} h={"16px"} as={item.icon} />}
            </Box>
          )}
          <VStack align={"start"} flexGrow={1}>
            <Text fontWeight={600}>{item.title}</Text>
            {item.text && (
              <Text color={"gray.600"}>
                {item.isChanged && item.originalValue ? (
                  <>
                    <Text as="span" color="green.500" ml={2} fontWeight={600}>
                      {item.modifiedValue}
                    </Text>
                    <Text
                      as="span"
                      color="red.500"
                      ml={2}
                      textDecoration="line-through"
                    >
                      ({item.originalValue ?? item.text})
                    </Text>
                  </>
                ) : (
                  item.text
                )}
              </Text>
            )}
            {item.headingText && (
              <Heading size={"lg"} color={"gray.600"}>
                {item.headingText}
              </Heading>
            )}
          </VStack>
        </HStack>
      ))}
    </Stack>
  </Container>
);
